import { AuthStore } from './AuthStore';
export let authStore;
export function initAuthStore(input) {
    authStore = new AuthStore(input.appDB);
}
